import * as Dati from "./Dati";
import * as Glob from "./Globale";
import { Dictionary } from "./Dati";
import * as Data from "./Data";

export class CRisAPIDatoTipiInfo_Comparatore extends Dati.CRisAPIDatoTipiInfo<Dati.CDatiPolizza> {
    constructor() {
        super();
        this.Dato = new Dati.CDatiPolizza();
        this.Dato.DataFine = new Data.CDateTZLess(this.Dato.DataEffetto).AddYears(1).ToDateNotNull();
        //this.Tipi = {};
        //this.Info = {};
    }
}

export class CComparatoreSingolo {
    ID_TipoProdotto: number = 0;
    DatoRCPPolizza: any;
    PolizzeJSON: Glob.DatiJSON | any = "";
    GaranzieJSON: Glob.DatiJSON | any = "";
    CampiPolizza?: { [I: string]: Dati.CInfoCampo };
    TipoProdotto: string;
    PreventivoSelezionato: boolean;
}

export const SemaforoRosso = "R";
export const SemaforoGiallo = "G";
export const SemaforoVerde = "V";
export const MinAge: number = 20;
export const MinDateOfBirth = new Data.CData(undefined, true).AddAnni(-MinAge).Data;

export class CRisAPIRCPInfo extends Dati.CRisAPI {
    Polizze: Dati.CRisAPILista<CRCPRisCalcolo>[] = [];
    //Garanzie: CRCPGaranzia[] = [];
    Garanzie: CCampoGaranziaVisualizzazione[] = [];
}

export class RCPPolizza {
    DatoRCPPolizza: any;
    Polizze: any;
    Garanzie: any;
    Frazionamento: number = 0;
    DatiAssociati: CComparatoreSingolo[];
}

export class CRCPRisCalcolo {
    ID_Binder: number = 0;
    ID_BinderCompagnia: number = 0;
    ID_AnagCompagniaBinder: number = 0;
    Compagnia: string = "";
    ImportoLordo: number = 0;
    ImportoNetto: number = 0;
    ID_TipoGaranzia: string = "";
    NomeClasseGaranzia: string = "";
    Errore: boolean = false;
    Messaggio: string = "";
    Semaforo: string = SemaforoVerde;
    Dati: Dictionary<any> = {};
    PremioNettoMaggiorato: number = 0;
    Accessori: number = 0;
    Flessibilita: number = 0;
    LimiteAccessori: number = 0;
    LimiteFlessibilita: number = 0;
    Scoperto: number = 0;
    ScopertoMin: number = 0;
    ScopertoMax: number = 0;
}

export class CRCPPolizze {
    Polizze: CRCPPolizza[] = [];
    Parametri: Dictionary<any> = {};
}

export class CRCPPolizzeStudiAssociati extends CRCPPolizze {
    PolizzeAssociati: CRCPPolizze[] = [];
}

export class CRCPPolizza {
    ID_Binder: number = 0;
    ID_BinderCompagnia: number = 0;
    ID_AnagCompagniaBinder: number = 0;
    Compagnia: string = "";
    ImportoLordo: number = 0;
    ImportoNetto: number = 0;
    ID_TipoGaranzia: string = "";
    NomeClasseGaranzia: string = "";
    Garanzie: CRCPGaranzia[] = [];
    LimiteAccessori: number = 0;
    LimiteFlessibilita: number = 0;
    Scoperto: number = 0;
    ScopertoMin: number = 0;
    ScopertoMax: number = 0;
}

export class CRCPGaranziaBase {
    ID_TipoGaranzia: string = "";
}

export class CRCPGaranzia extends CRCPGaranziaBase {
    NomeClasseGaranzia: string = "";
}

export class CRCPGaranziaVisualizzazione extends CRCPGaranziaBase {
    NomeClasseGaranzia: Dictionary<string> = {};
}

/* PRODOTTI E GARANZIE BASE E ACCESSORIE INIZIO */
export class CGaranzia {
    NomeClasseGaranzia: string = "";
    ID_TipoGaranzia: string = "";
    Base: boolean = false;
    ImportoLordo: number = 0;
    ImportoNetto: number = 0;
    Abilitata: boolean = true;
    Semaforo: string = SemaforoVerde;
    MigliorPremio: number = Glob.PremioStandard;
    Messaggio: string = "";
    Dati: Dictionary<any> = {};
    Selezionata: boolean = false;
}

export class Associato {
    ID_TipoProdotto: number = 0;
    TipoProdotto: string = "";
    DatoRCPPolizza: any;
    Dati = new CRisAPIDatoTipiInfo_Comparatore();
    AnagraficaJSON: Glob.DatiJSON = "{}";
    RecapitiJSON: Glob.DatiJSON = "{}";
    IndirizziJSON: Glob.DatiJSON = "{}";
    DatiProfessionaliJSON: Glob.DatiJSON = "{}";
}

export class CProdotto {
    ID_Binder: number = 0;
    ID_BinderCompagnia: number = 0;
    ID_AnagCompagniaBinder: number = 0;
    Compagnia: string = "";
    Logo: string = "";
    GaranziaBase: CGaranzia = new CGaranzia();
    GaranzieAccessorie: CGaranzia[] = [];
    PremioNettoMaggiorato: number = 0;
    Accessori: number = 0;
    Flessibilita: number = 0;
    LimiteAccessori: number = 0;
    LimiteFlessibilita: number = 0;
    Scoperto: number = 0;
    ScopertoMin: number = 0;
    ScopertoMax: number = 0;

    public GetGaranziaAccessoria(nome: string): CGaranzia {
        let risultato: CGaranzia = new CGaranzia();
        if (this.GaranzieAccessorie.filter(g => g.ID_TipoGaranzia == nome).length > 0) risultato = this.GaranzieAccessorie.filter(g => g.ID_TipoGaranzia == nome)[0];
        return risultato;
    }

    public CalcolaImportoLordoTotaleCache: number;

    public CalcolaImportoLordoTotale(): number {
        let totale: number = 0;
        totale += this.GaranziaBase.ImportoLordo;
        for (let i: number = 0; i < this.GaranzieAccessorie.length; i++) totale += this.GaranzieAccessorie[i].ImportoLordo;

        this.CalcolaImportoLordoTotaleCache = totale;
        return totale;
    }

    public CalcolaImportoLordoMaggiorato(): number {
        let totale: number = 0;
        totale += this.CalcolaImponibile() + this.CalcolaTasse();
        //for (let i: number = 0; i < this.GaranzieAccessorie.length; i++)
        //    totale += this.GaranzieAccessorie[i].ImportoLordo;

        return totale;
    }

    public CalcolaImportoNettoTotale(): number {
        let totale: number = 0;
        totale += this.GaranziaBase.ImportoNetto;
        for (let i: number = 0; i < this.GaranzieAccessorie.length; i++) totale += this.GaranzieAccessorie[i].ImportoNetto;

        return totale;
    }

    public CalcolaImponibile(): number {
        let PremioNetto: number = 0;
        //if (this.PremioNettoMaggiorato > this.GaranziaBase.ImportoNetto)
        //    PremioNetto = this.PremioNettoMaggiorato;
        //else
        //    PremioNetto = this.GaranziaBase.ImportoNetto;

        PremioNetto = this.PremioNettoMaggiorato;
        PremioNetto = PremioNetto - (PremioNetto * this.Flessibilita) / 100;

        return PremioNetto + (PremioNetto * this.Accessori) / 100;
    }

    public CalcolaTasse(): number {
        return (this.CalcolaImponibile() * 22.25) / 100;
    }

    public NumeroGaranzieParzialiCache: number;

    public NumeroGaranzieParziali(): number {
        let risultato: number = 0;

        //if (!this.GaranziaBase.Abilitata)
        //    return this.GaranzieAccessorie.length + 1;

        if (this.GaranziaBase.Semaforo == SemaforoRosso) return this.GaranzieAccessorie.length + 1;

        if (this.GaranziaBase.Semaforo == SemaforoGiallo) return this.GaranzieAccessorie.length + 0.5;

        //for (let i: number = 0; i < this.GaranzieAccessorie.length; i++)
        //    if (!this.GaranzieAccessorie[i].Abilitata)
        //        risultato++;

        for (let i: number = 0; i < this.GaranzieAccessorie.length; i++) {
            if (this.GaranzieAccessorie[i].Semaforo == SemaforoGiallo) risultato += 0.5;
            else if (this.GaranzieAccessorie[i].Semaforo == SemaforoRosso) risultato += 1;
        }

        this.NumeroGaranzieParzialiCache = risultato;
        return risultato;
    }

    public ColorePolizza(): string {
        let semaforo: string = SemaforoVerde;

        semaforo = this.GetSemaforo(semaforo, this.GaranziaBase.Semaforo);

        for (let i: number = 0; i < this.GaranzieAccessorie.length; i++) {
            semaforo = this.GetSemaforo(semaforo, this.GaranzieAccessorie[i].Semaforo);
        }

        return semaforo;
    }

    private GetSemaforo(semaforoAttuale: string, semaforoNuovo: string): string {
        if (semaforoNuovo == SemaforoRosso) semaforoAttuale = SemaforoRosso;

        if (semaforoNuovo == SemaforoGiallo && semaforoAttuale != SemaforoRosso) semaforoAttuale = SemaforoGiallo;

        return semaforoAttuale;
    }
}

export class CCampoGaranziaBase {
    ID_TipoGaranzia: string = "";
    Descrizione: string = "";
    Icona: string = "fa fa-file-signature";
    Selezionata: boolean = false;
    ProprietaSelezione: string = "S";
}

export class CCampoGaranzia extends CCampoGaranziaBase {
    NomeClasseGaranzia: Dictionary<string> = {};
}

export class CCampoGaranziaVisualizzazione extends CCampoGaranziaBase {
    NomeClasseGaranzia: Dictionary<string> = {};
}
/* PRODOTTI E GARANZIE BASE E ACCESSORIE FINE */

export class CBinderProdottiGaranzie {
    ID_BinderProdottoGaranzia: number = 0;
    ID_Binder: number = 0;
    ID_TipoRamo: number = 0;
    TipoRamo: string = "";
    ID_TipoProdotto: number = 0;
    TipoProdotto: string = "";
    DatiTipoProdotto: string = "";
    ID_BinderCompagnia: number = 0;
    ID_TipoGaranzia: string = "";
    NomeClasseGaranzia: string = "";
    Descrizione: string = "";
    Ordine: number = 0;
    ProprietaSelezione: string = "S";
    Icona: string = "fa fa-file-signature";

    constructor(ID_Binder: number = 0, ID_BinderCompagnia: number = 0) {
        this.ID_Binder = ID_Binder;
        this.ID_BinderCompagnia = ID_BinderCompagnia;
        this.NomeClasseGaranzia = "";
        this.Descrizione = "";
        this.Ordine = 0;
        this.ProprietaSelezione = "S";
        this.Icona = "fa fa-file-signature";
    }
}

export class CRisAPIBinderProdottiGaranzie extends Dati.CRisAPIListaTipi<CBinderProdottiGaranzie> {
    constructor() {
        super();
        this.Dati = [];
    }
}



// WEBPACK FOOTER //
// ./src/DatiRCP.tsx